import type {
  AdminTokenAccessMode,
  AdminTokenModule,
  AdminTokenModuleGrant,
} from '../types/adminToken';

// Sensitive opt-in grants never participate in the ordinary global defaults.
export const DEFAULT_TOKEN_MODULES: AdminTokenModule[] = [
  'basic',
  'access',
  'app',
  'llm',
  'release',
  'computer',
  'diagnostics',
  'room_capacity',
  'test_management',
];
export function tokenModuleGrants(
  mode: AdminTokenAccessMode,
  detailed: boolean,
  modes: Partial<Record<AdminTokenModule, 'none' | AdminTokenAccessMode>>,
  acquisition: boolean,
): AdminTokenModuleGrant[] {
  const grants: AdminTokenModuleGrant[] = DEFAULT_TOKEN_MODULES.filter(
    (module) => !detailed || modes[module] !== 'none',
  ).map((module) => ({
    module,
    accessMode: detailed ? (modes[module] as AdminTokenAccessMode) : mode,
  }));
  if (acquisition) grants.push({ module: 'acquisition', accessMode: 'read' });
  return grants;
}
